export default __webpack_public_path__ + "static/media/0.6a347031.png";